export const PAGE_URL = Object.freeze({
  SITE_CONCIERGE: 'site-concierge',
  INTELLIGENT_SEARCH: 'intelligent-search',
  PLAYBOOKS: 'playbooks',
  EMAIL_CAMPAIGNS: 'email/campaigns',
  CHAT_PLAYBOOKS: 'playbooks/chat',
  FASTLANE_PLAYBOOKS: 'playbooks/fastlane',
  SALES_RESULTS: 'sales',
  CONVERSATIONS: 'conversations',
  MEETINGS: 'meetings',
  CALLS: 'calls',
  REVENUE_OVERVIEW: 'revenue/overview',
  REVENUE_OPPORTUNITIES: 'revenue/opportunities',
  EMAIL_PLAYBOOKS: 'playbooks/email',
  CONVO_ANALYSIS: 'conversations/analysis',
  TEAM_PERFORMANCE: 'team',
  TEAM_AVAILABILITY: 'availability',
  ROUTING: 'routing',
  SERVICE: 'service',
  REAL_TIME: 'real-time',
  CONVO_DETAIL: 'conversations/data',
})
